export default __webpack_public_path__ + "static/media/get-your-business-online.f88af591.jpg";